








import { Component, Prop, Vue } from "vue-property-decorator";
import { ContentBoxModel } from "@/contentful/models";

enum BoxColor {
  Dark = "Dark",
  Light = "Light",
  None = "None",
}

@Component
export default class Box extends Vue {
  @Prop() private item!: ContentBoxModel;

  get boxColorClass(): string {
    if (this.item.fields.color === BoxColor.Dark) {
      return "box--dark";
    }
    if (this.item.fields.color === BoxColor.Light) {
      return "box--light";
    }
    return "";
  }

  get boxButtonClass(): string {
    if (this.item.fields.color === BoxColor.Light) {
      return "btn-outlined--light";
    }
    return "";
  }

  get target(): string {
    if (this.item.fields.file) {
      return "_blank";
    }
    return "";
  }

  get url(): string {
    if (this.item.fields.url) {
      return this.item.fields.url;
    } else if (this.item.fields.file) {
      return this.item.fields.file.fields.file.url;
    }
    return "";
  }
}
